import { multiSelectFilter, createActionsColumn, urlCell } from '../columnUtils';

export const createIcd10ToActiveDxColumns = (setSelectedItem, setDrawerVisible, handleDelete) => [
  {
    id: 'groupCode',
    header: 'Group Code',
    accessorKey: 'groupCode',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'matchType',
    header: 'Match Type',
    accessorKey: 'matchType',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'pattern',
    header: 'Pattern',
    accessorKey: 'pattern',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'priority',
    header: 'Priority',
    accessorKey: 'priority',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'description',
    header: 'Description',
    accessorKey: 'description',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceUrl',
    header: 'Source URL',
    accessorKey: 'sourceUrl',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  createActionsColumn(setSelectedItem, setDrawerVisible, handleDelete)
];
